var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.374,
    r: 10,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.292 15.112c-.905 0-1.703-.21-2.394-.63a4.467 4.467 0 01-1.624-1.778C5.892 11.948 5.7 11.08 5.7 10.1s.192-1.848.574-2.604a4.467 4.467 0 011.624-1.778c.69-.43 1.489-.644 2.394-.644s1.704.215 2.394.644a4.466 4.466 0 011.624 1.778c.392.756.588 1.624.588 2.604 0 .607-.08 1.176-.238 1.708-.159.523-.378.99-.658 1.4l1.246 1.246-1.162 1.162-1.246-1.246c-.354.243-.746.43-1.176.56-.43.121-.886.182-1.372.182zm0-1.652c.495 0 .943-.117 1.344-.35l-1.218-1.232 1.078-1.064 1.148 1.148c.261-.532.392-1.153.392-1.862 0-.663-.117-1.246-.35-1.75-.224-.504-.541-.896-.952-1.176-.401-.29-.877-.434-1.428-.434-.56 0-1.045.145-1.456.434-.41.28-.728.672-.952 1.176-.224.504-.336 1.087-.336 1.75s.108 1.25.322 1.764c.224.504.542.896.952 1.176.41.28.896.42 1.456.42z",
    fill: "#6D6D6D"
  })));
}

export default SvgIconFaq;